import * as React from 'react';
import { SearchStringContainer } from '../SearchStringContainer';
import { DesktopFiltersContainer } from '../DesktopFiltersContainer';

import styles from './SearchStringBlockContainer.css';
import { Button } from '@cian/ui-kit';
import { IconActionMap16 } from '@cian/ui-kit-design-tokens/icons';
import { useFiltersUpdatedEvent } from '../../hooks/filters';
import { EPageKind } from '../../types/page';
import { trackSearchButtonClick, trackSearchOnMapButtonClick } from '../../components/FiltersSearchButtons/tracking';
import { Experiment } from '@cian/experiments/ab';
import { AUD_DESKTOP_BX206_SEARCH_STRING_DESKTOP } from '../../constants/experiments';
import { useApplicationContext } from '../../utils/applicationContext';

const FILTERS_MODAL_OPEN_EVENT = 'filter:click';

export const SearchStringBlockContainer: React.FC = () => {
  const { microfrontendsAPI } = useApplicationContext();
  const { searchMeta } = useFiltersUpdatedEvent();

  React.useEffect(() => {
    const onFiltersModalOpen = () => {
      if (microfrontendsAPI) {
        microfrontendsAPI.getDesktopFiltersMicrofrontendAPI().openAllFiltersModal();
      }
    };

    addEventListener(FILTERS_MODAL_OPEN_EVENT, onFiltersModalOpen);

    return () => {
      removeEventListener(FILTERS_MODAL_OPEN_EVENT, onFiltersModalOpen);
    };
  }, [microfrontendsAPI]);

  const onSearchListClick = () => {
    if (searchMeta?.fullUrl) {
      trackSearchButtonClick(EPageKind.Default, searchMeta.fullUrl);
      window.location.href = searchMeta.fullUrl;
    }
  };

  const onSearchMapClick = () => {
    if (searchMeta?.mapUrl) {
      trackSearchOnMapButtonClick(EPageKind.Default, searchMeta.mapUrl);
      window.location.href = searchMeta.mapUrl;
    }
  };

  return (
    <>
      <Experiment name={AUD_DESKTOP_BX206_SEARCH_STRING_DESKTOP} group="B">
        <div className={styles['block-container']}>
          <SearchStringContainer />
        </div>
      </Experiment>

      <Experiment name={AUD_DESKTOP_BX206_SEARCH_STRING_DESKTOP} group="C">
        <SearchStringContainer />
        <div style={{ display: 'none' }}>
          <DesktopFiltersContainer />
        </div>
      </Experiment>

      <Experiment name={AUD_DESKTOP_BX206_SEARCH_STRING_DESKTOP} group="D">
        <div className={styles['block-container']}>
          <div>
            <SearchStringContainer />
            <DesktopFiltersContainer />
          </div>
          <div className={styles['button-container']}>
            <Button onClick={onSearchListClick}>Найти</Button>
            <Button
              theme="fill_secondary"
              afterIcon={<IconActionMap16 color="icon-main-default" />}
              onClick={onSearchMapClick}
            >
              На карте
            </Button>
          </div>
        </div>
      </Experiment>
    </>
  );
};
